import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { VariantStyleSelectorComponent } from './variant-style-selector.component';

@NgModule({
  imports: [CommonModule, RouterModule, UrlModule, I18nModule, VariantStyleSelectorComponent],
  exports: [VariantStyleSelectorComponent],
})
export class VariantStyleSelectorModule {}
